<script>
  export let href;
  export let download = null;
</script>

{#if href !== false}

  <a {href} download={download || null}><slot /></a>

{:else}

  <slot/>

{/if}